<div class="ml-5 mr-5" >
    <h2>
    {{ 'menu-trash' | translateWithFallback }}
    </h2>

    <div class="flex-row">
    <dx-tab-panel #tabPanel [showNavButtons]="true" [selectedIndex]="selectedIndex" [loop]="false" [animationEnabled]="false" [swipeEnabled]="true" iconPosition='start' (selectedIndexChange)="changeSelectTabIndex($event)">
        <dxi-item [title]="isSmallScreen ? '' :('machine-info' | translateWithFallback)"  icon='info'>
            <div class="ml-3 mr-3">
                <app-machine-info-trash></app-machine-info-trash>
            </div>
        </dxi-item>
        <dxi-item [title]="isSmallScreen ? '' :('medium' | translateWithFallback)" icon='file'>
            <div class="ml-3 mr-3">
                <app-medium-trash></app-medium-trash>
            </div>
        </dxi-item>
        <dxi-item [title]="isSmallScreen ? '' :('machine-activity' | translateWithFallback)" icon='datatrending'>
            <div class="ml-3 mr-3">
                <app-machine-activity-trash></app-machine-activity-trash>
            </div>
        </dxi-item>
        <dxi-item [title]="isSmallScreen ? '' :('machine-part-info' | translateWithFallback)" icon='toolbox'>
            <div class="ml-3 mr-3">
                <app-machine-part-info-trash></app-machine-part-info-trash>
            </div>
        </dxi-item>
    </dx-tab-panel>
    </div>
</div>
